export default __webpack_public_path__ + "static/media/trus20.7d6a681c.png";